var _path, _path2, _path3, _path4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFreeProgram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3872 42.4918C49.3872 42.5066 49.3823 42.5203 49.3741 42.5314H53.7705C53.8972 42.5315 54 42.638 54 42.7692V43.7383V43.8722V44.3891H53.9239C53.712 45.0886 53.0815 45.596 52.3366 45.596H3.66345C2.91848 45.596 2.28796 45.0886 2.07608 44.3891H2V43.8722V43.7383V42.772C2 42.6392 2.10402 42.5314 2.23219 42.5314H6.69212C6.68383 42.5202 6.67892 42.5065 6.67892 42.4916V16.2644C6.67892 15.019 7.70317 14 8.95501 14H47.1111C48.3629 14 49.3872 15.019 49.3872 16.2644V42.4918Z",
    fill: "url(#paint0_linear_42_17208)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.3884 16.0547H8.43018V40.7875H47.3884V16.0547Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3231 15.1357C28.349 14.9767 28.2405 14.827 28.0807 14.8012C27.9209 14.7754 27.7704 14.8833 27.7445 15.0423C27.7185 15.2012 27.827 15.351 27.9868 15.3768C28.1466 15.4026 28.2971 15.2946 28.3231 15.1357Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2867 23.5109C27.6128 20.5983 30.0837 18.334 33.0835 18.334C36.3051 18.334 38.9168 20.9457 38.9168 24.1673V25.6272C42.1384 25.6273 44.7499 28.2389 44.7499 31.4605C44.7499 34.6822 42.1382 37.2938 38.9166 37.2938H17.0416C13.8199 37.2938 11.2083 34.6822 11.2083 31.4605C11.2083 28.2388 13.8199 25.6272 17.0416 25.6272H19.2793C20.2877 23.8828 22.1734 22.709 24.3331 22.709C25.4109 22.709 26.4204 23.0013 27.2867 23.5109Z",
    fill: "url(#paint1_linear_42_17208)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_42_17208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9814 30.4268L27.9598 26.4051L23.7466 30.6183",
    stroke: "white",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9463 26.9995L27.9463 34.5828",
    stroke: "white",
    strokeWidth: 1.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_17208",
    x1: 7.85,
    y1: 19.9242,
    x2: 47.0058,
    y2: 25.6392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_42_17208",
    x1: 14.9817,
    y1: 21.889,
    x2: 40.1568,
    y2: 25.8387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD8258"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD3C2F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_42_17208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10.8333,
    height: 10.8333,
    fill: "white",
    transform: "translate(33.4167 24.832) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFreeProgram);
export default __webpack_public_path__ + "static/media/icon_free_program.a12a9e02a77678152a024f27ad1c7e4a.svg";
export { ForwardRef as ReactComponent };